export const CTA_TYPES = [
  { label: 'Không có CTA', value: 0 },
  { label: 'Text', value: 1 },
  { label: 'Image', value: 2 },
];

export const CTA_TYPE_OBJ = {
  NOTHING: 0,
  TEXT: 1,
  IMAGE: 2,
};

export const MAX_SIZE_MB = 3;
